<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.5 23.5">
		<path fill="currentColor" d="M16.75 23.5h-16a.7502.7502 0 0 1-.75-.75v-22A.7502.7502 0 0 1 .75 0h10a.74942.74942 0 0 1 .53027.21973l6 6A.75027.75027 0 0 1 17.5 6.75v16a.7502.7502 0 0 1-.75.75ZM1.5 22H16V7.06055L10.43945 1.5H1.5Z"/>
		<g fill="currentColor">
			<path d="m10.75.75 3 3 3 3h-6Z"/>
			<path d="M16.75 7.25h-6a.49971.49971 0 0 1-.5-.5v-6a.5.5 0 0 1 .85352-.35352l6 6A.5.5 0 0 1 16.75 7.25Zm-5.5-1h4.293L11.25 1.957Z"/>
		</g>
		<path d="M8.75 18.25a4.5 4.5 0 1 1 4.5-4.5.5.5 0 0 1-1 0 3.50155 3.50155 0 1 0-1.10645 2.55273.50018002.50018002 0 1 1 .68555.72852A4.47961 4.47961 0 0 1 8.75 18.25Z"/>
		<path d="M11.9082 18.25a.49972.49972 0 0 1-.5-.5v-1.18457h-1.18457a.5.5 0 0 1 0-1h1.68457a.49971.49971 0 0 1 .5.5V17.75a.49971.49971 0 0 1-.5.5Z"/>
	</svg>
</template>
